<template>
    <div class="card attraction-card" @mouseenter="$emit('move-map')">
        <a :href="'/' + pageSlug + '/' + attraction.slug" class="poster" :style="'background-image: url(' + (attraction.image ? attraction.image : '/assets/images/backgrounds/tour/tour-1.jpg') + ')'"></a>
        <div class="card-body">
            <h4 class="card-title">{{ attraction.title }}</h4>
            <p class="card-description" v-html="attraction.short_description"></p>
            <div class="card-actions">
                <a :href="'/' + pageSlug + '/' + attraction.slug" class="btn btn-primary w-100">Learn more</a>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "AttractionCard",
    props: {
        attraction: {
            required: true
        },
        layout: {
            type: String,
            default: 'tour'
        },
        pageSlug: {
            type: String,
            default: 'attraction'
        }
    }
}
</script>

<style scoped>

</style>
